import { useTranslation } from 'react-i18next';
import { CheckIcon } from '@heroicons/react/24/outline';

import { createHandle } from 'services/breadcrumbs/breadcrumbs';
import { PaymentReconciliationRoutes } from 'support/types';
import { Button } from 'components/Form/Button/Button';
import { Page } from 'components/Page/Page';

export const PaymentReconciliationPitch = () => {
  const { t } = useTranslation();

  const features = [
    t('paymentReconciliation:pitch.features.receivePaymentData'),
    t('paymentReconciliation:pitch.features.automaticallyCloseInvoices'),
    t('paymentReconciliation:pitch.features.spotUnderpayments'),
    t('paymentReconciliation:pitch.features.plugPaymentData'),
  ];

  const handleRequestFeature = () => {
    window.open(
      'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ38t0hJtzx7N-g-T0PuDIE2QS4qB1c7QA_uaB8RiqCuAB0YjYrzWYYRs-gLRPYtej_WWguDkmeV',
      '_blank',
    );
  };

  const handleLearnMore = () => {
    window.open(
      `${t('paymentReconciliation:pitch.learnMoreLink')}?utm_source=app&utm_medium=portal&utm_campaign=payment_reconciliation_pitch`,
      '_blank',
    );
  };

  return (
    <Page>
      <div className="absolute inset-y-0 right-0 w-1/2 bg-linear-to-bl/srgb from-[#E7FBF7] from-0% via-[#C9D3FC]/30 via-30% to-[#C9D3FC]/0 to-50%"></div>
      {/* Content positioned left-center like in Figma */}
      <div className="flex h-full justify-between gap-12 overflow-x-hidden">
        <div className="w-2/5 space-y-10 px-16 py-20">
          <div className="inline-flex items-center rounded-[10px] border border-violet-100 bg-violet-50 px-2 py-0.5">
            <span className="text-xs font-medium text-violet-800">{t('paymentReconciliation:pitch.badge')}</span>
          </div>

          <div className="space-y-3">
            <h1 className="text-2xl leading-8 font-extrabold text-gray-900">
              {t('paymentReconciliation:pitch.title')}
            </h1>
            <p className="text-sm leading-5 text-gray-700">{t('paymentReconciliation:pitch.subtitle')}</p>
          </div>

          <div className="space-y-2">
            {features.map((feature, index) => (
              <div key={index} className="flex items-start gap-3">
                <div className="shrink-0">
                  <CheckIcon className="size-5 text-emerald-400" aria-hidden="true" />
                </div>
                <p className="text-sm leading-5 text-gray-700">{feature}</p>
              </div>
            ))}
          </div>

          <div className="flex gap-2">
            <Button
              type="button"
              variant="primary"
              onClick={handleRequestFeature}
              analyticsId="payment-reconciliation-request-feature"
            >
              {t('paymentReconciliation:pitch.requestFeature')}
            </Button>
            <Button
              type="button"
              variant="secondary"
              onClick={handleLearnMore}
              analyticsId="payment-reconciliation-learn-more"
            >
              {t('paymentReconciliation:pitch.learnMore')}
            </Button>
          </div>
        </div>
        <div className="relative w-3/5">
          <img
            className="absolute top-96 right-0 w-225 -rotate-6 skew-x-12 rounded-lg shadow-[-3px_4px_0px_0px_rgba(201,211,252,1.00),-25px_42px_64px_0px_rgba(201,211,252,0.50),0px_12px_14px_0px_rgba(0,0,0,0.25)]"
            src={t('paymentReconciliation:pitch.image2Url')}
            alt={t('paymentReconciliation:pitch.title')}
          />
          <img
            className="absolute top-28 right-0 w-225 -rotate-6 skew-x-12 rounded-lg shadow-[-3px_4px_0px_0px_rgba(201,211,252,1.00),-25px_42px_64px_0px_rgba(201,211,252,0.50),0px_12px_14px_0px_rgba(0,0,0,0.25)]"
            src={t('paymentReconciliation:pitch.image1Url')}
            alt={t('paymentReconciliation:pitch.title')}
          />
        </div>
      </div>
    </Page>
  );
};

PaymentReconciliationPitch.handle = createHandle(() => {
  return {
    label: (t) => t('paymentReconciliation:pitch.title'),
    to: PaymentReconciliationRoutes.pitch,
    key: PaymentReconciliationRoutes.pitch,
  };
});
